export default __webpack_public_path__ + "static/media/colored_transparent_logo.e3ee6970.webp";